import UntrackedModel from "./untracked/untrackedModel";
import Repo from "../state/modules/repo";
import IRepo from "../interfaces/repo";

export default class Share extends UntrackedModel {
  role_ids: string[] = [];

  static repo: IRepo<Share> = new Repo<Share>('shares', Share);

  get rootName() {
    return 'shares';
  }
}